module.exports = __webpack_public_path__ + "static/media/koalefanttrunksteak.829fe116.webp";